import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import { Router } from 'vue-router'

export const initSentry = (params: { app: App; router: Router }) => {
  const IS_PROD = process.env.NODE_ENV === 'production'
  if (!IS_PROD) return

  const { app, router } = params
  Sentry.init({
    app,
    dsn: 'https://6eb2dbc64db520dcab270b696e26d592@sentry.teemdrop.com/4',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    release: process.env.GIT_HEAD_TAG,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 0.2,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/acbuy\.com\/prefix-api/],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
